<div class="modal-header scroller">
    <h3>Page Workflow</h3>
    <div class="spriteBtns">
        <button class="back09" title="Save Workflow" (click)="onSubmit()">
            <svg>
                <use [attr.xlink:href]="srcPath.saveIcon"></use>
            </svg>
        </button>
        <button type="button" class="back07" title="Close" (click)="closeModal()">
            <svg>
                <use [attr.xlink:href]="srcPath.closeIcon"></use>
            </svg>
        </button>
    </div>
</div>
<div class="modal-body">
    <form [formGroup]="pageWorkflowForm">
        <div class="page-validation-style">
            <div class="form-row boder-bottom-gray">
                <div class="col">
                    <!--  -->
                    <label for="" class="control-label inputcontrol" style="text-decoration: underline;">Define Control
                        Action
                        <div class="add-sprit-btn spriteBtns marginLeft5 margin-left-5">
                            <button class="back03" title="Add Workflow" (click)="addPageWorkflow()">
                                <svg class="icon">
                                    <use href="../../assets/img/common-sprite.svg#addPlus"></use>
                                </svg>
                            </button>
                        </div>
                    </label>
                </div>
            </div>
            <ng-container formArrayName="selectedColumns"
                *ngFor="let slColumns of pageWorkflowForm.get('selectedColumns')['controls'];let cIndex=index">
                <div class="cell-editing-panel" [formGroupName]="cIndex">
                    <div class="form-row boder-bottom-gray padding-top-5">
                        <div class="col">
                            <label for="" class="control-label">Select Control</label>
                            <ng-select *ngIf="allControls.length>0" class="form-control" appendTo="body"
                                formControlName="controlName" placeholder="Choose Control" [items]="allControls"
                                bindLabel="label" bindValue="inputid" (change)="onControlchange($event,cIndex)">
                            </ng-select>
                        </div>
                        <div class="col-3">
                            <label for="" class="control-label">Action</label>
                            <ng-select *ngIf="actionTypeOptions.length>0" class="form-control" appendTo="body"
                                formControlName="actionName" placeholder="Choose Action" [items]="actions"
                                bindLabel="name" bindValue="id"></ng-select>
                        </div>
                        <div class="col-1">
                            <label class="control-label lbl-height"></label>
                            <div class="delete-sprit-btn spriteBtns">
                                <button class="back06" title="Delete" (click)="deleteMainControl(cIndex)">
                                    <svg class="icon">
                                        <use href="../../assets/img/common-sprite.svg#trash"></use>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- </div>  -->
                    <div class="form-row boder-bottom-gray padding-top-5 padding-bottom-10"></div>
                    <div class="form-row" style="padding-bottom: 10px;">
                        <div class="col">
                            <label for="" class="control-label"></label>
                            <textarea class="form-control" formControlName="sqlQuery"
                                placeholder="Select * from "></textarea>
                        </div>
                    </div>

                    <div class="form-row boder-bottom-gray padding-top-10"></div>
                    <div class="form-row">
                        <div class="form-row boder-bottom-gray padding-top-5">
                            <div class="col">
                                <label for="" class="control-label">Add Where Condition
                                    <div class="add-sprit-btn spriteBtns marginLeft5 margin-left-5">
                                        <button class="back03" title="Add Where Condition"
                                            (click)="addWhereConditionForPageWorkflow(cIndex)">
                                            <svg class="icon">
                                                <use href="../../assets/img/common-sprite.svg#addPlus"></use>
                                            </svg>
                                        </button>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                    <ng-container class="padding-top-5" formArrayName="whereCondition"
                        *ngFor="let tColumns of getWhereCondition(slColumns);let wIndex=index">
                        <div [formGroupName]="wIndex">
                            <div class="form-row margin-btm-split">
                                <div class="col">
                                    <label for="" class="control-label">Column</label>
                                    <ng-select *ngIf="pvAllColumns.length>0 " class="form-control" appendTo="body"
                                        formControlName="columnName" placeholder="Choose Column" [items]="pvAllColumns"
                                        bindLabel="name" bindValue="id" (change)="loadSqlStatement(slColumns,cIndex)">
                                    </ng-select>
                                </div>
                                <div class="col">
                                    <label for="" class="control-label">Operator</label>
                                    <ng-select class="form-control" appendTo="body" formControlName="operator"
                                        placeholder="Choose Operator" [items]="operatorOptions" bindLabel="name"
                                        bindValue="id" (change)="loadSqlStatement(slColumns,cIndex)">
                                    </ng-select>
                                </div>
                                <div class="col-1">
                                    <label class="control-label lbl-height"></label>
                                    <div class="delete-sprit-btn spriteBtns">
                                        <button class="back06" title="Delete"
                                            (click)="deleteWhereConditionForPageWorkflow(cIndex,wIndex)">
                                            <svg class="icon">
                                                <use href="../../assets/img/common-sprite.svg#trash"></use>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row margin-bottom-5">
                                <div class="col">
                                    <label for="" class="control-label">Value</label>
                                    <input type="text" class="form-control" formControlName="value"
                                        placeholder="Enter Value" (change)="loadSqlStatement(slColumns,cIndex)">
                                </div>
                                <div class="col">
                                    <label for="" class="control-label">Condition</label>
                                    <ng-select class="form-control" appendTo="body" formControlName="condition"
                                        placeholder="Choose Condition" [items]="JoinTypeOptions" bindLabel="name"
                                        bindValue="id" (change)="loadSqlStatement(slColumns,cIndex)"></ng-select>
                                </div>
                                <div class="col-1"></div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
        <div style="padding-top: 10px;">
            <div class="form-row margin-btm-split">
                <div class="col">
                    <h4 style="text-decoration: underline;">User Workflow</h4>
                </div>
                <div class="col-1">
                    <label class="control-label lbl-height"></label>
                    <div class="delete-sprit-btn spriteBtns">
                        <button class="back06" title="Delete" (click)="deleteUserWorkflow()">
                            <svg class="icon">
                                <use href="../../assets/img/common-sprite.svg#trash"></use>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <hr style="width:1px;color:grey;">
            <div class="form-row margin-btm-split">
                <div class="col">
                    <div class="form-group">
                        <label class="control-label">Display Name</label>
                        <input rows="4" class="form-control input-sm" type="text" placeholder="Enter display name"
                            formControlName="displayName">
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label class="control-label">Is First Page</label>
                        <ng-select class="form-control " appendTo="body" formControlName="isFirstPage"
                            [items]="booleanOptions" bindLabel="name" bindValue="id" placeholder="select"
                            [ngClass]="{'is-invalid': submitted && f.isFirstPage.errors}"></ng-select>
                    </div>
                </div>
            </div>
            <div class="form-row margin-btm-split">
                <div class="col">
                    <div class="form-group">
                        <label class="control-label">Page Type</label>
                        <ng-select class="form-control " appendTo="body" formControlName="pageType"
                            [items]="pageTypeOptions" bindLabel="name" bindValue="id" placeholder="select"
                            [ngClass]="{'is-invalid': submitted && f.pageType.errors}"></ng-select>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label class="control-label">Save Next Page</label>
                        <ng-select class="form-control " appendTo="body" formControlName="saveNextPage"
                            [items]="booleanOptions" bindLabel="name" bindValue="id" placeholder="select"
                            [ngClass]="{'is-invalid': submitted && f.saveNextPage.errors}"
                            (change)="onSaveNextPageChange($event)"></ng-select>
                    </div>
                </div>
            </div>
            <div class="form-row margin-btm-split">
                <div class="col" *ngIf="saveNextPageFlag==1">
                    <div class="form-group">
                        <label for="" class="control-label">Next Page</label>
                        <ng-select *ngIf="allPageList.length>0 " class="form-control" appendTo="body"
                            formControlName="nextPageId" placeholder="Choose Column" [items]="allPageList"
                            bindLabel="gstibo_menu_name" bindValue="gstibo_page_id">
                        </ng-select>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label class="control-label">Linked Table</label>
                        <ng-select class="form-control" formControlName="lnkTableName" [items]="dynamicTables"
                            placeholder="Select Table" bindLabel="gstibo_table_name" bindValue="gstibo_table_name"
                            (change)="loadSelTableColumns()"></ng-select>
                    </div>
                </div>
            </div>
            <div class="form-row margin-btm-split">
                <div class="col">
                    <div class="form-group">
                        <label class="control-label">Selection Column</label>
                        <ng-select class="form-control" formControlName="columnName" [items]="tableColumns"
                            placeholder="Select Column" bindLabel="column_name" mul bindValue="column_name"
                            [multiple]="false"></ng-select>
                    </div>
                </div>
                <div class="col">
                    <!-- <div class="form-group">
                                <label class="control-label">Linked Table</label>
                                <ng-select class="form-control" formControlName="lnkTableName" [items]="dynamicTables"
                                placeholder="Select Table" bindLabel="gstibo_table_name" bindValue="gstibo_table_name"
                                (change)="loadSelTableColumns()"></ng-select>
                        </div>      -->
                </div>
            </div>

        </div>


        <div class="page-validation-style">
            <div class="form-row boder-bottom-gray">
                <div class="col">
                    <label for="" class="control-label inputcontrol" style="text-decoration: underline;">Mail Merge
                        Settings
                        <div class="add-sprit-btn spriteBtns" style="margin-left: 3px;">
                            <button class="back03" title="Add Settings" (click)="addMailMergeSettings()">
                                <svg class="icon">
                                    <use href="../../assets/img/common-sprite.svg#addPlus"></use>
                                </svg>
                            </button>
                        </div>
                    </label>
                </div>
            </div>
            <div class="form-row boder-bottom-gray padding-top-5">
                <div class="col">
                    <label for="" class="control-label">Select Parent Table</label>
                    <ng-select *ngIf="dynamicTables.length>0" class="form-control" appendTo="body"
                        formControlName="parenttableName" placeholder="Choose Table" [items]="dynamicTables"
                        bindLabel="gstibo_table_name" bindValue="gstibo_table_name" (change)="getSelTableCols()">
                    </ng-select>
                </div>
                <div class="col">
                    <label for="" class="control-label">Primary Key</label>
                    <ng-select class="form-control" appendTo="body" formControlName="parentPrColName"
                        placeholder="Choose Linking Column" [items]="parent_columns_list" bindLabel="name"
                        bindValue="name"></ng-select>
                </div>
            </div>
            <div class="form-row" style="padding-bottom: 10px;">
                <div class="col">
                    <label for="" class="control-label"></label>
                    <textarea class="form-control" formControlName="sqlQueryMM" rows="4"
                        placeholder="Select * from "></textarea>
                </div>
            </div>
            <ng-container formArrayName="selectedColumnsMM"
                *ngFor="let slColumns of pageWorkflowForm.get('selectedColumnsMM')['controls'];let cIndex=index">
                <div class="cell-editing-panel" [formGroupName]="cIndex">
                    <div class="form-row boder-bottom-gray padding-top-5">
                        <div class="col">
                            <label for="" class="control-label">Select Table</label>
                            <ng-select *ngIf="dynamicTables.length>0" class="form-control" appendTo="body"
                                formControlName="tableName" placeholder="Choose Table" [items]="dynamicTables"
                                bindLabel="gstibo_table_name" bindValue="gstibo_table_name"
                                (change)="getPageTable(cIndex)">
                            </ng-select>
                        </div>
                        <div class="col">
                            <label for="" class="control-label">Linking Column</label>
                            <ng-select class="form-control" appendTo="body" formControlName="lnkColName"
                                placeholder="Choose Linking Column" [items]="mm_columns_list[cIndex]" bindLabel="name"
                                bindValue="name" (change)="loadSqlStatementMM()"></ng-select>
                        </div>
                        <div class="col-1">
                            <label class="control-label lbl-height"></label>
                            <div class="delete-sprit-btn spriteBtns">
                                <button class="back06" title="Delete" (click)="deleteMailMergeMain(cIndex)">
                                    <svg class="icon">
                                        <use href="../../assets/img/common-sprite.svg#trash"></use>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="cell-editing-panel_sub">
                        <div class="form-row">
                            <div class="form-row boder-bottom-gray padding-top-10 ">
                                <div class="col">
                                    <label for="" class="control-label">Add Content
                                        <div class="add-sprit-btn spriteBtns marginLeft5 margin-left-5">
                                            <button class="back03" title="Add Content" (click)="addContent(cIndex)">
                                                <svg class="icon">
                                                    <use href="../../assets/img/common-sprite.svg#addPlus"></use>
                                                </svg>
                                            </button>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <ng-container class="padding-top-5" formArrayName="mailmergecontent"
                            *ngFor="let tColumns of getMailMergeContent(slColumns);let wIndex=index">
                            <div [formGroupName]="wIndex">
                                <div class="form-row margin-btm-split">
                                    <div class="col">
                                        <label for="" class="control-label">Column</label>
                                        <ng-select class="form-control" appendTo="body" formControlName="columnName"
                                            placeholder="Choose Column" [items]="mm_columns_list[cIndex]"
                                            bindLabel="name" bindValue="name" (change)="getPageTable(cIndex)">
                                        </ng-select>
                                    </div>
                                    <div class="col">
                                        <label for="" class="control-label">Replace Content</label>
                                        <input type="text" class="form-control" formControlName="content"
                                            placeholder="Enter Content">
                                    </div>
                                    <div class="col-1">
                                        <label class="control-label lbl-height"></label>
                                        <div class="delete-sprit-btn spriteBtns">
                                            <button class="back06" title="Delete"
                                                (click)="deleteContent(cIndex,wIndex)">
                                                <svg class="icon">
                                                    <use href="../../assets/img/common-sprite.svg#trash"></use>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                    </div>

                </div>
            </ng-container>
        </div>
        <div class="form-row margin-btm-split">
            <div class="col-3">
                <div class="form-group">
                    <label class="control-label">Is Outlook Page</label>
                    <ng-select class="form-control " appendTo="body" formControlName="isOutlookPage"
                        [items]="booleanOptions" bindLabel="name" bindValue="id" placeholder="select"
                        [ngClass]="{'is-invalid': submitted && f.isOutlookPage.errors}"></ng-select>
                </div>
            </div>
            <div class="col-3">
                <div class="form-group">
                    <label class="control-label">Is eCabinet Page</label>
                    <ng-select class="form-control " appendTo="body" formControlName="iseCabinetPage"
                        [items]="booleanOptions" bindLabel="name" bindValue="id" placeholder="select"
                        [ngClass]="{'is-invalid': submitted && f.iseCabinetPage.errors}"></ng-select>
                </div>
            </div>
            <div class="col-3">
                <div class="form-group">
                    <label class="control-label">Apply User Rights</label>
                    <ng-select class="form-control " appendTo="body" formControlName="applyuserrights"
                        [items]="booleanOptions" bindLabel="name" bindValue="id" placeholder="select"
                        [ngClass]="{'is-invalid': submitted && f.applyuserrights.errors}"></ng-select>
                </div>
            </div>
        </div>
    </form>

</div>
<div class="modal-footer">
</div>